import i18n, {getI18nDefaultLanguage, setI18nLanguage} from '@/lang/lang'

export default (to, from, next, injection) => {
  const routeLang = to?.params?.lang || from?.params?.lang
  const langExists = routeLang && i18n.messages.hasOwnProperty(routeLang) && i18n.languages?.find(l => l.locale === routeLang)?.active
  const lang = langExists ? routeLang : getI18nDefaultLanguage()?.locale
  if (langExists) setI18nLanguage(lang)
  // next()
}
